import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../_redux/paypalRequestsActions';
import * as commonColumnFormatters from '../../_common/column-formatters';
import * as columnFormatters from './column-formatters';
import {usePaypalRequestsContext} from '../context/PaypalRequestsContext';
import useInfiniteScrollControl from '../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../_common/components/CommonGrid/CommonGrid";

export function PaypalRequestsTable() {
  const prefix = 'paypal-requests-column';
  const intl = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'agentData',
      Header: intl.formatMessage({id: `${prefix}-agentData`, defaultMessage: 'Agent'})
    },
    {
      accessor: 'customerData',
      Header: intl.formatMessage({id: `${prefix}-customerData`, defaultMessage: 'Customer'})
    },
    {
      accessor: 'paymentData',
      Header: intl.formatMessage({id: `${prefix}-paymentData`, defaultMessage: 'Payment data'})
    },
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({id: `${prefix}-createdAt`, defaultMessage: 'Created at'})
    },
    {
      accessor: 'invoiceID',
      Header: intl.formatMessage({id: `${prefix}-invoiceID`, defaultMessage: 'Invoice ID'})
    },
    {
      accessor: 'paypalPaymentID',
      Header: intl.formatMessage({id: `${prefix}-paypalPaymentID`, defaultMessage: 'Paypal payment ID'})
    },
    {
      accessor: 'paymentStatus',
      Header: intl.formatMessage({id: `${prefix}-paymentStatus`, defaultMessage: 'Status'})
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        agentData: columnFormatters.AgentDataColumnFormatter(item),
        customerData: columnFormatters.CustomerDataColumnFormatter(item),
        paymentData: columnFormatters.PaymentDataColumnFormatter(item),
        createdAt: commonColumnFormatters.DateTimeColumnFormatter(item.createdAt),
        invoiceID: commonColumnFormatters.BoldColumnFormatter(item.invoiceID),
        paypalPaymentID: commonColumnFormatters.BoldColumnFormatter(item.paypalPaymentID),
        paymentStatus: columnFormatters.StatusColumnFormatter(item.paymentStatus),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'paypalRequests',
    UIContext: usePaypalRequestsContext(),
    getNewEntities: actions.getPaypalRequests,
    getNextEntities: actions.getNextPaypalRequests,
    onEntitiesChange: entities => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'paypal-table'}
    />
  );
}
